import React from 'react'
import { Component } from 'react'
import ReactAnimationFrame from 'react-animation-frame';
import PropTypes from 'prop-types';

const minimumRotations = 4;
const maximumRotations = 6;
const rotationTime = 17000; // In milliseconds, maybe vary slightly because of randomness
const rotationPerNotch = 1.0 / 9.0;
const flipperRotationOffset = 0.015;

class Wheel extends Component {
  constructor(props) {
    super(props);

    this.state = {startTime: 0, endTime: 0, amountToRotate: 0, notches: 0, rotationDeg: 0, flipperRotate: 0};
  }

  componentWillMount() {
    this.wheel = document.getElementById('wheel');
    this.flipper = document.getElementById('flipper');
  }

  componentWillReceiveProps(props) {
    if (!this.props.playing && props.playing) {
      this.start(props);
    }
  }

  render() {
    let resultClass = (!this.props.playing && !this.props.idling) ? 'result-' + this.props.result : '';

    return <div>
      <div
        id="wheel" style={{
          transform: 'rotate(-' + this.state.rotationDeg.toString() + 'deg)'
          }}
        className={'wheel ' + resultClass}>
      </div>

      <div
        className="flipper"
        id="flipper"
        style={{
          transform: 'rotate(' + this.state.flipperRotate.toString() + 'deg)'
          }}>
      </div>
    </div>
  }

  start(props) {
    this.setState({startTime: 0, endTime: 0, amountToRotate: 0, notches: 0, rotationDeg: 0, flipperRotate: 0});
    this.click = props.assets.get('click');

    let startTime = performance.now();
    this.setState({startTime: startTime});
    this.setState({endTime: startTime + rotationTime});

    let finalPosition = (1.0 / 9.0) * props.result + (1.0 / 9.0) * Math.random();
    let amountToRotate = (finalPosition + 4.0);

    //if (this.props.result == 2) {
    //  amountToRotate += (1.0 / 9.0);
    //}

    this.setState({amountToRotate: amountToRotate});
  }

  expStep(x, k, n){
    return Math.exp(-k * Math.pow(x,n));
  }

  interpolate(x) {
    const min = this.expStep(0, 5, 1);
    const max = this.expStep(1, 5, 1);
//    console.log("max: " + max);

    return this.expStep(x, 5, 1) - max;
//    return (t - max) / (1.0 - max);
  }

  onAnimationFrame(time) {
    let done = false;
    if (!this.props.playing) {
      if (this.props.idling) {
        this.setState({rotationDeg: time * 0.02});
        this.setState({flipperRotate: 90});
      }

      return;
    }

    let t = (time - this.state.startTime) / rotationTime;

    if (t > 1.0) {
      done = true;
    }

    if (t < 0.0) { t = 0.0; }
    if (t > 1.0) { t = 1.0; }
    t = this.interpolate(t);
    //t = this.expStep(t, 5, 1);
    if (t < 0.0) { t = 0.0; }
    if (t > 1.0) { t = 1.0; }

    let invT = 1.0 - t;

    // Amount to rotate in "cycles". 1 = 360 degrees
    const rotation = this.state.amountToRotate * (invT) + flipperRotationOffset;
    const rotationDeg = rotation * 360;
    const invRotation = this.state.amountToRotate * invT;

    let notches = Math.floor(invRotation / rotationPerNotch - flipperRotationOffset);
    if (notches > this.state.notches) {
      this.click.pause();
      this.click.currentTime = 0;
      this.click.play();
      this.setState({notches: notches});
    }


    let flipperAmount = 0.2;
    let flipperRemainder = invRotation / rotationPerNotch - flipperRotationOffset;   
    flipperRemainder = flipperRemainder - Math.floor(flipperRemainder);
    flipperRemainder -= (1.0 - flipperAmount);
    flipperRemainder /= flipperAmount;

    if (flipperRemainder < 0.0) {
      flipperRemainder = 0.0;
    }

    if (flipperRemainder > 1.0) {
      flipperRemainder = 1.0;
    }

//    console.log("t: " + t);
//    console.log("int t: " + invT);
    let flipperRotate = flipperRemainder * 42.0;
    this.setState({rotationDeg: rotationDeg});
    this.setState({flipperRotate: flipperRotate});

    if (done && (time > this.state.endTime + 200)) {
      this.props.onDone();
    }
  }
}

Wheel.propTypes = {
  assets: PropTypes.object.isRequired,
  loaded: PropTypes.bool.isRequired,
  playing: PropTypes.bool.isRequired,
  idling: PropTypes.bool.isRequired,
  result: PropTypes.number.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default ReactAnimationFrame(Wheel);


// WEBPACK FOOTER //
// ./src/app/components/Wheel.js